module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/Bold/sdgIcons/sdg8-fab84dc7d138c36b15f79c9039bf2bb3.png";